import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faCalendarAlt,
  faCalendarWeek,
} from "@fortawesome/free-solid-svg-icons";

const CalendarCustomToolbar = ({ label, onNavigate, onView, view }) => {
  return (
    <>
      {/* Mobile media query - apenas reduz tamanho dos botões */}
      <style>{`
        @media (max-width: 768px) {
          .calendar-toolbar-button {
            font-size: 14px !important;
            padding: 6px 8px !important;
          }
        }
      `}</style>

      <div style={container}>
        {/* Controles superiores */}
        <div style={topRow}>
          <div style={group}>
            <button
              onClick={() => onNavigate("PREV")}
              style={button}
              className="calendar-toolbar-button"
            >
              <FontAwesomeIcon icon={faChevronLeft} />
              <span className="button-label"> Anterior</span>
            </button>
            <button
              onClick={() => onNavigate("NEXT")}
              style={button}
              className="calendar-toolbar-button"
            >
              <span className="button-label">Próximo</span>
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>

          <div style={group}>
            <button
              onClick={() => onView("month")}
              style={{
                ...button,
                backgroundColor: view === "month" ? "#99B0AD" : "#fff",
                color: view === "month" ? "white" : "#99B0AD",
                border: "1px solid #99B0AD",
              }}
              className="calendar-toolbar-button"
            >
              <FontAwesomeIcon icon={faCalendarAlt} />
              <span className="button-label"> Mês</span>
            </button>
            <button
              onClick={() => onView("week")}
              style={{
                ...button,
                backgroundColor: view === "week" ? "#99B0AD" : "#fff",
                color: view === "week" ? "white" : "#99B0AD",
                border: "1px solid #99B0AD",
              }}
              className="calendar-toolbar-button"
            >
              <FontAwesomeIcon icon={faCalendarWeek} />
              <span className="button-label"> Semana</span>
            </button>
          </div>
        </div>

        {/* Título do mês/semana */}
        <div style={labelStyle}>{label}</div>
      </div>
    </>
  );
};

export default CalendarCustomToolbar;

// --- Estilos ---
const container = {
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  padding: "6px 10px",
};

const topRow = {
  display: "flex",
  justifyContent: "space-between",
  flexWrap: "nowrap",
  overflowX: "auto",
  gap: "10px",
};

const group = {
  display: "flex",
  flexWrap: "nowrap",
  gap: "6px",
};

const button = {
  padding: "7px 12px",
  fontSize: "14.5px",
  borderRadius: "6px",
  border: "1px solid #ccc",
  backgroundColor: "#fff",
  color: "#4D5E5B",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  whiteSpace: "nowrap",
  gap: "4px",
};

const labelStyle = {
  textAlign: "center",
  fontSize: "16px",
  fontWeight: "600",
  color: "#99B0AD",
  whiteSpace: "nowrap",
};
